import React, { useEffect, useState } from 'react';
import Box from 'bharat-ui/web/Box';
import { makeStyles } from 'bharat-ui/web/Styles';
import { formatCurrency } from 'utils/formatCurrency';
import FormControlLabel from 'bharat-ui/web/FormControlLabel';
import Loader from 'bharat-ui/web/Loader';
import LoaderNew from 'components/atoms/Loader';
import Typography from 'bharat-ui/web/Typography';
import { triggerUpdateJuspayCashbackApi, UpdateJuspayCashbackSlice, useUpdateJuspayCashback } from 'Slices';
import Checkbox from 'bharat-ui/web/Checkbox';
import Icon from 'bharat-ui/web/Icon';
import IconAvatar from 'bharat-ui/web/IconAvatar';
import check from '../../../assets/images/postpeCheck1.svg';
import uncheck from '../../../assets/images/postpeUncheck1.svg';
import postpeMoneyWhite from 'assets/images/postpeMoneyWhite.svg';
import rentalOfferIcon from 'assets/images/rentalOfferIcon.png';
import { registerSlice } from 'store';
import { useDispatch } from 'react-redux';
import { getURLParameter, removePostpeLoader, showPostpeLoader } from 'utils/nativeSupport';
import { showPostPeUI, showTwelvePcUI, showZillionUi } from 'utils/Utils';

registerSlice(UpdateJuspayCashbackSlice);

declare global {
	interface Window {
		callbackHyperSdkInit: any;
		callbackHyperSdkPaymentSuccess: any;
		callbackHyperSdkPaymentError: any;
	}
}

const isShowTwelvePcUI = showTwelvePcUI();
const isShowPostPeUI = showPostPeUI();
const isShowZillionUi = showZillionUi();

const useStyle = makeStyles(() => ({
	postPeAmountCard: {
		backgroundColor: '#009CDE',
		color: '#ffffff',
	},
	postpeCashbackCardMargin: {
		marginRight: '0 !important',
	},
	paymentHeader: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
	},
	amountPayStyle: {
		fontFamily: 'PoppinsRegular',
		fontSize: '13px',
		lineHeight: '19px',
	},
	amountPayValue: {
		fontFamily: 'PoppinsMedium',
		fontSize: '28px',
		lineHeight: '36px',
	},
	postpeCashbackCardColor: {
		backgroundColor: '#E9F8FF',
	},
	whiteCardColor: {
		backgroundColor: '#FFFFFF !important',
	},
	greyCardColor: {
		backgroundColor: '#E2E2E2',
	},
	amountCashbackStyle: {
		fontFamily: 'PoppinsLight',
		fontSize: '15px',
		lineHeight: '19px',
		color: '#000000',
	},
	availableCashback: {
		fontFamily: 'PoppinsMedium',
		fontSize: '15px',
		lineHeight: '19px',
		color: '#4F4F4F',
	},
	paymentModal: {
		gap: '16px',
		padding: '16px',
		backgroundColor: '#035857',
	},
	subHeader: {
		color: '#FFFFFF',
	},
	paymentSubHeader: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		paddingTop: '8px',
		color: '#FFFFFF',
	},
	subHeader1: {
		paddingTop: '4px',
	},
	rupeeSymbolUnity: {
		fontSize: '18px',
		lineHeight: '30px',
		color: '#FFFFFF',
	},
	paymentModalBp: {
		gap: '16px',
		padding: '16px',
		backgroundColor: isShowZillionUi ? '#29623F' : '#2B80FF',
		color: '#FFFFFF',
	},
	amountPayValueBp: {
		fontFamily: 'PoppinsHeavy',
		fontSize: '18px',
		lineHeight: '30px',
	},
	totalAmountBp: {
		fontFamily: 'PoppinsHeavy',
		fontSize: '15px',
		lineHeight: '20px',
	},
	rupeeSymbolTotal: {
		fontSize: '15px',
		lineHeight: '20px',
		color: '#FFFFFF',
	},
	amountPayStyleBp: {
		fontFamily: 'PoppinsLight',
		fontSize: '13px',
		lineHeight: '19px',
	},
	rupeeSymbolSurcharge: {
		fontSize: '13px',
		lineHeight: '19px',
		color: '#FFFFFF',
	},
	horizontalLine: {
		border: 'none',
		height: '1px',
		margin: 0,
		flexShrink: 0,
		backgroundColor: '#ffffff',
	},
}));

const JuspayMicroWebView: React.FC<any> = () => {
	const classes = useStyle();
	const dispatch = useDispatch();
	const updateJuspayCashbackData = useUpdateJuspayCashback();

	const payableAmount = getURLParameter(window.location.href, 'totalAmount') || 0;
	const cashbackBalance = getURLParameter(window.location.href, 'availableCashback') || '0';
	const isShowSurcharge = getURLParameter(window.location.href, 'surchargeEnabled') === 'true' ? true : false;
	const [loading, setLoading] = useState(false);
	const [isCashbackCheckboxChecked, setIsCashbackCheckboxChecked] = useState(
		!!(getURLParameter(window.location.href, 'checkbox') === 'true'),
	);

	const handlePostpeCashbackCheckbox = () => {
		const payload = {
			redeemables: [
				{
					key: 'cashback',
					displayText: 'apply cashback',
					amount: cashbackBalance,
					checked: !isCashbackCheckboxChecked,
				},
			],
		};
		if (isShowPostPeUI) {
			showPostpeLoader({ first_message: 'loading', start_index: 0, range: 7, second_message: 'please wait' });
		} else {
			setLoading(true);
		}
		dispatch(triggerUpdateJuspayCashbackApi(payload));
	};

	useEffect(() => {
		if (updateJuspayCashbackData?.data?.payloads?.updateOrder) {
			setIsCashbackCheckboxChecked(!isCashbackCheckboxChecked);
			setLoading(false);
			removePostpeLoader();
			processJuspayPayment(updateJuspayCashbackData?.data?.payloads?.updateOrder);
		}
	}, [updateJuspayCashbackData?.data]);

	useEffect(() => {
		if (updateJuspayCashbackData.error.length > 1) {
			setLoading(false);
			removePostpeLoader();
			console.log('===================updateJuspayCashbackData error data======================');
		}
	}, [updateJuspayCashbackData.error && !updateJuspayCashbackData.loading]);

	const processJuspayPayment = async (updateOrder: any) => {
		const parsedExternalPgPayload = JSON.parse(updateOrder);
		const nativeData = {
			key: 102,
			payload: parsedExternalPgPayload,
			deeplink: '',
		};
		console.log('===================callbackHyperSdkPaymentSuccess payload======================');
		await window.androidObj.nativeSupport(JSON.stringify(nativeData));

		window.callbackHyperSdkPaymentSuccess = (jsonString: any) => {
			console.log('===================callbackHyperSdkPaymentSuccess status======================');
		};

		window.callbackHyperSdkPaymentError = (jsonString: any) => {
			//redirect here
			console.log('===================callbackHyperSdkPaymentError status======================', jsonString);
		};
	};

	const amountToPay = Number(payableAmount) - Number(isCashbackCheckboxChecked ? cashbackBalance : 0);
	const surcharge = amountToPay * 0.0004 * 1.18;

	return (
		<>
			{isShowPostPeUI ? null : isShowTwelvePcUI || isShowZillionUi ? (
				<LoaderNew loading={loading} loaderType={isShowTwelvePcUI ? '12pc' : 'zillion'} />
			) : (
				<Loader loading={loading} />
			)}
			<div className="flex flex-column">
				{isShowPostPeUI ? (
					<Box className={`${classes.postPeAmountCard} p4`}>
						<Box className={classes.paymentHeader}>
							<Box display="flex" flexDirection="column">
								<span className={classes.amountPayStyle}>Amount to pay</span>
								<span className={classes.amountPayValue}>{`₹${formatCurrency(
									Number(payableAmount) - Number(isCashbackCheckboxChecked ? cashbackBalance : 0),
								)}`}</span>
							</Box>
							<img src={postpeMoneyWhite} className="" />
						</Box>
					</Box>
				) : isShowTwelvePcUI ? (
					<Box className={classes.paymentModal}>
						<Box display="flex" flexDirection="column">
							<Box className={classes.paymentHeader}>
								<Typography variant="Light300" className={classes.subHeader}>
									Add to:
								</Typography>
								<Typography variant="Light300" className={classes.subHeader}>
									Amount
								</Typography>
							</Box>
							<Box className={`${classes.paymentSubHeader} mt2`}>
								<Typography variant="SemiBold500">12% Club</Typography>
								<Typography variant="SemiBold500">{`₹${formatCurrency(amountToPay)}`}</Typography>
							</Box>

							{isShowSurcharge && (
								<>
									<Box className={`${classes.paymentSubHeader} mt2`}>
										<Typography variant="Light300" className={classes.subHeader}>
											Platform Fee
										</Typography>
										<Typography variant="Light300" className={classes.subHeader}>
											{`₹${formatCurrency(surcharge)}`}
										</Typography>
									</Box>
									<hr className={`my2 ${classes.horizontalLine}`} />
									<Box className={classes.paymentHeader}>
										<Typography variant="SemiBold300" className={classes.subHeader}>
											Total
										</Typography>
										<Typography variant="SemiBold300" className={classes.subHeader}>
											{`₹${formatCurrency(amountToPay + surcharge)}`}
										</Typography>
									</Box>
								</>
							)}
						</Box>
					</Box>
				) : (
					<Box className={classes.paymentModalBp}>
						<Box display="flex" flexDirection="column">
							<Box className={classes.paymentHeader}>
								<span className={classes.amountPayStyleBp}>Paying to:</span>
								<span className={classes.amountPayStyleBp}>Amount</span>
							</Box>
							<Box className={classes.paymentSubHeader}>
								<span className={classes.amountPayValueBp}>{isShowZillionUi ? 'Zillion' : 'BharatPe'}</span>
								<div className="">
									<span className={classes.rupeeSymbolUnity}>₹&nbsp;</span>
									<span className={classes.amountPayValueBp}>{`${formatCurrency(amountToPay)}`}</span>
								</div>
							</Box>
							{isShowSurcharge && (
								<>
									<Box className={classes.paymentSubHeader}>
										<span className={classes.amountPayStyleBp}>Platform Fee</span>
										<div className="">
											<span className={classes.rupeeSymbolSurcharge}>₹&nbsp;</span>
											<span className={classes.amountPayStyleBp}>{`${formatCurrency(surcharge)}`}</span>
										</div>
									</Box>
									<hr className={`my2 ${classes.horizontalLine}`} />
									<Box className={classes.paymentHeader}>
										<span className={classes.totalAmountBp}>Total</span>
										<div className="">
											<span className={classes.rupeeSymbolTotal}>₹&nbsp;</span>
											<span className={classes.totalAmountBp}>{`${formatCurrency(amountToPay + surcharge)}`}</span>
										</div>
									</Box>
								</>
							)}
						</Box>
					</Box>
				)}
				{!!(Number(cashbackBalance) > 0) && (
					<Box className={`${classes.postpeCashbackCardColor} p4`} onClick={handlePostpeCashbackCheckbox}>
						<Box className={`${classes.whiteCardColor} ${classes.paymentHeader} p4`}>
							<Box display="flex" alignItems="center">
								<IconAvatar
									icon={{
										icon: rentalOfferIcon,
										width: 18,
										height: 18,
									}}
									className={`mr4 ${classes.greyCardColor}`}
								/>
								<Box display="flex" flexDirection="column">
									<span className={classes.amountCashbackStyle}>Available Cashback:&nbsp;</span>
									<span className={classes.availableCashback}>{`₹${formatCurrency(cashbackBalance)}`}</span>
								</Box>
							</Box>
							<FormControlLabel
								className={classes.postpeCashbackCardMargin}
								control={
									<Checkbox
										checked={isCashbackCheckboxChecked}
										className="py0"
										checkedIcon={<Icon icon={check} height={16} />}
										icon={<Icon icon={uncheck} height={16} />}
									/>
								}
								label={''}
							/>
						</Box>
					</Box>
				)}
			</div>
		</>
	);
};

export default JuspayMicroWebView;
